import React from 'react'
import Helmet from 'react-helmet'
import { backendURL } from '../../data/config.json'

//Components
import Fleet from '../../components/Fleet'

const CompactEs = props => (
  <div className="page Compact">
  <Helmet
          title={`Vehículos Compactos para alquilar | Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Preguntas frecuentes sobre el alquiler de autos.',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'es',
              href:
                './en/fleet/compact', 
            },
          ]}
        />
    <h1>Compacto</h1>
    <Fleet
      lang={props.pathContext.langKey}
      types={props.data.dataJson.fleetTypes}
      fleet={props.data.dataJson.fleet}
      features={props.data.dataJson.fleetFeatures}
      category={10}
    />
  </div>
)

export const query = graphql`
  query CompactES {
    dataJson(id: { regex: "/fleet/" }) {
      ...FleetData
    }
    allFile(filter: { relativeDirectory: { eq: "fleet" } }) {
      edges {
        node {
          name
          childImageSharp {
            resolutions {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`

export default CompactEs



// WEBPACK FOOTER //
// ./src/pages/fleet/compact.es.js